import React, { useEffect, useMemo, useRef, useState } from "react";
import { api } from "../api";
import SelectCliente from "../components/ui/selectCliente";
import { showError, showSuccess } from "../utils/toast";
import MainLayout from "../components/mainLayout";
import RelatorioAgendamentosModal from "../components/RelatorioAgendamentosModal";
import "../sass/pages/agendamentosScreen.scss";

const hojeISO = () => new Date().toISOString().slice(0, 10);

const initialForm = {
  funcAgendou: "",
  codFunc: "",
  tecnico: "",
  chvCad: "",
  cliente: "",
  dataISO: hojeISO(),
  hrInicio: "",
  tempoExec: "01:00",
  hrFim: "",
  descrServ: "",
  pedidoCliente: "",
  anotacoes: "",
  online: "",
  confirmado: false,
  contatoConfirmacao: "",
  idChamados: null,
  kmDia: "",
  veiculo: "",
  placa: "",
};

const defaultPermissoes = {
  podeAgendar: false,
  podeEditar: false,
  podeExcluir: false,
  podeConfirmar: false,
  podeFinalizar: false,
  podeVerTodos: false,
  podeEmitirRelatorio: false,
  podeGerenciarPermissoes: false,
  carregado: false,
  encontrado: false,
  bloqueado: false,
  funcionario: null,
  vigenciaInicio: null,
  vigenciaFim: null,
  motivo: null,
  observacao: null,
  escopo: "GLOBAL",
  valorEscopo: null,
  permissoesDetalhe: [],
};

const asBool = (v) => {
  if (typeof v === "boolean") return v;
  if (typeof v === "number") return v === 1;

  const s = String(v ?? "").trim().toUpperCase();
  return ["1", "TRUE", "S", "SIM", "YES"].includes(s);
};

const getCodOperador = () =>
  sessionStorage.getItem("codFunc") ||
  sessionStorage.getItem("CodFunc") ||
  sessionStorage.getItem("CODFUNC") ||
  "";

const getIdFuncionarioPermissao = () =>
  sessionStorage.getItem("IdFuncionario") ||
  sessionStorage.getItem("idFuncionario") ||
  sessionStorage.getItem("DevId") ||
  "";

const getNomeOperador = () =>
  sessionStorage.getItem("Nome") ||
  sessionStorage.getItem("UserName") ||
  sessionStorage.getItem("RazaoSocial") ||
  sessionStorage.getItem("usuario") ||
  "";

const toStr = (v) => String(v ?? "").trim();

const parseAPIDate = (val) => {
  if (!val) return 0;

  const t = Date.parse(val);
  if (!Number.isNaN(t)) return t;

  const m = String(val).match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (m) return new Date(`${m[3]}-${m[2]}-${m[1]}T00:00:00`).getTime();

  return 0;
};

const fmtDataBR = (s) => {
  const ts = parseAPIDate(s);
  if (!ts) return "—";

  try {
    return new Date(ts).toLocaleDateString("pt-BR");
  } catch {
    return "—";
  }
};

const fmtISOToBR = (iso) => {
  if (!iso) return "";
  const [y, m, d] = String(iso).split("-");
  if (!y || !m || !d) return iso;
  return `${d}/${m}/${y}`;
};

const fmtDataHoraBR = (value) => {
  if (!value) return "";

  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";

  return d.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const fmtVigenciaPermissao = (inicio, fim) => {
  const ini = fmtDataHoraBR(inicio) || "agora";
  const end = fmtDataHoraBR(fim) || "sem vencimento";
  return `${ini} até ${end}`;
};

const trunc = (s, max = 60) => {
  const txt = toStr(s);
  return txt.length > max ? `${txt.slice(0, max - 1)}…` : txt;
};

const minuteOf = (hhmm) => {
  if (!/^\d{2}:\d{2}$/.test(String(hhmm || ""))) return 999999;
  const [h, m] = String(hhmm).split(":").map((x) => parseInt(x, 10));
  return h * 60 + m;
};

const toHHMM = (h) => {
  if (!h) return "";
  const [HH = "00", mm = "00"] = String(h).split(":");
  return `${HH.padStart(2, "0").slice(0, 2)}:${mm.padStart(2, "0").slice(0, 2)}`;
};

const joinAddress = (parts = []) => parts.map(toStr).filter(Boolean).join(", ");

const montarEndereco = (obj = {}) => {
  if (!obj) return "";

  if (obj.Latitude && obj.Longitude) return `${obj.Latitude},${obj.Longitude}`;
  if (obj.latitude && obj.longitude) return `${obj.latitude},${obj.longitude}`;

  if (obj.EnderecoCompleto) return toStr(obj.EnderecoCompleto);
  if (obj.enderecoCompleto) return toStr(obj.enderecoCompleto);

  const logradouro =
    obj.LocalLogradouro ||
    obj.Endereco ||
    obj.endereco ||
    obj.Logradouro ||
    obj.logradouro ||
    obj.Rua ||
    obj.rua ||
    "";

  const numero = obj.Numero || obj.numero || "";
  const bairro = obj.Bairro || obj.bairro || "";
  const cidade = obj.Cidade || obj.cidade || obj.Municipio || obj.municipio || "";
  const uf = obj.UF || obj.uf || obj.Estado || obj.estado || "";
  const cep = obj.CEP || obj.cep || "";

  return joinAddress([logradouro, numero, bairro, cidade, uf, cep]);
};

const getClienteNome = (obj = {}) => {
  const safe = obj || {};

  return (
    safe.RazaoSocial ||
    safe.Cliente ||
    safe.cliente ||
    safe.NomeFant ||
    safe.Nome ||
    ""
  );
};

const getAgendaId = (item) => item?.id ?? item?.ID ?? item?.Id ?? null;

const getFilaId = (item) => item?.id ?? item?.ID ?? item?.Id ?? item?.IdChamados ?? null;

const formatKm = (v) => {
  const n = Number(v || 0);
  if (!Number.isFinite(n) || n <= 0) return "0 km";
  return `${n.toLocaleString("pt-BR", {
    minimumFractionDigits: n < 10 ? 2 : 1,
    maximumFractionDigits: 2,
  })} km`;
};

const isPresencialRota = (row = {}) => {
  const tipo = String(row?.Online || row?.online || "").trim().toUpperCase();

  if (!tipo) return true;
  return tipo !== "ONLINE";
};

const montarParadaRota = (row = {}) => {
  const endereco = montarEndereco(row);

  if (!endereco) return null;

  const parada = {
    idAgendamento: getAgendaId(row),
    cliente: row.Cliente || row.cliente || "Cliente não informado",
    endereco,
    horario: row.HrInicio || row.hrInicio || "",
    servico: row.DescrServ || row.descrServ || "",
  };

  const lat = row.Latitude ?? row.latitude ?? row.Lat ?? row.lat;
  const lon =
    row.Longitude ??
    row.longitude ??
    row.Lon ??
    row.lon ??
    row.Lng ??
    row.lng;

  if (lat != null && lon != null) {
    parada.lat = lat;
    parada.lon = lon;
  }

  return parada;
};

const normalizeClienteFromSelect = (cli = {}) => {
  const safe = cli || {};

  return {
    CodigoCad: safe.CodigoCad ?? safe.CodCad ?? safe.ChvCad ?? "",
    RazaoSocial: safe.RazaoSocial || safe.NomeFant || safe.Nome || "",
    EnderecoCompleto: montarEndereco(safe),
    Raw: safe,
  };
};

export default function Agendamentos() {
  const [form, setForm] = useState(initialForm);
  const [listaAgenda, setListaAgenda] = useState([]);
  const [fila, setFila] = useState([]);
  const [tecnicos, setTecnicos] = useState([]);
  const [permissoes, setPermissoes] = useState(defaultPermissoes);

  const [loading, setLoading] = useState(false);
  const [loadingAgenda, setLoadingAgenda] = useState(false);
  const [loadingFila, setLoadingFila] = useState(false);
  const [loadingPermissao, setLoadingPermissao] = useState(false);

  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [agendamentoSelecionado, setAgendamentoSelecionado] = useState(null);
  const [filaSelecionada, setFilaSelecionada] = useState(null);
  const [mapTarget, setMapTarget] = useState(null);
  const [relOpen, setRelOpen] = useState(false);

  const [rotaOtimizada, setRotaOtimizada] = useState(null);
  const [loadingRota, setLoadingRota] = useState(false);
  const [rotaErro, setRotaErro] = useState("");
  const [voltarParaEmpresa, setVoltarParaEmpresa] = useState(true);

  const [filaSort, setFilaSort] = useState({ key: "Data", dir: "asc" });
  const [filaBusca, setFilaBusca] = useState("");
  const [mobilePanel, setMobilePanel] = useState("fila");

  const plannerRef = useRef(null);
  const hrInicioRef = useRef(null);

  /*
    Atenção:
    - codOperador vem da sessão como CodFunc_New em alguns logins, ex.: 46.
      Mantemos ele para carregar agenda/chamados do técnico.
    - idFuncionarioPermissao é o ID real da tabela Funcionarios, ex.: 34.
      Usamos ele exclusivamente para consultar permissões.
  */
  const codOperador = useMemo(() => getCodOperador(), []);
  const idFuncionarioPermissao = useMemo(() => getIdFuncionarioPermissao(), []);

  const modoEdicao = Boolean(agendamentoSelecionado);
  const podeCriar = permissoes.podeAgendar;
  const podeEditar = permissoes.podeEditar;
  const podeExcluir = permissoes.podeExcluir;
  const podeConfirmar = permissoes.podeConfirmar;
  const podeFinalizar = permissoes.podeFinalizar;
  const podeVerTodos = permissoes.podeVerTodos;
  const podeRelatorio = permissoes.podeEmitirRelatorio;

  const totalAgenda = listaAgenda.length;
  const totalConfirmados = listaAgenda.filter((x) => x.Pendente === "Confirmado").length;
  const totalPendentes = Math.max(totalAgenda - totalConfirmados, 0);
  const totalFila = fila.length;

  const agendaOrdenada = useMemo(() => {
    return [...listaAgenda].sort((a, b) => minuteOf(a.HrInicio) - minuteOf(b.HrInicio));
  }, [listaAgenda]);

  const paradasRota = useMemo(() => {
    return agendaOrdenada
      .filter((row) => isPresencialRota(row))
      .map(montarParadaRota)
      .filter(Boolean);
  }, [agendaOrdenada]);

  const agendaPorId = useMemo(() => {
    const map = new Map();

    agendaOrdenada.forEach((row) => {
      const id = getAgendaId(row);
      if (id != null) map.set(String(id), row);
    });

    return map;
  }, [agendaOrdenada]);

  const rotaPorAgendamento = useMemo(() => {
    const map = new Map();

    const itens = Array.isArray(rotaOtimizada?.ordemOtimizada)
      ? rotaOtimizada.ordemOtimizada
      : [];

    itens.forEach((item) => {
      if (item?.idAgendamento != null) {
        map.set(String(item.idAgendamento), item);
      }
    });

    return map;
  }, [rotaOtimizada]);

  const tecnicosDisponiveis = useMemo(() => {
    if (podeVerTodos) return tecnicos;
    return tecnicos.filter((u) => String(u.codFunc) === String(codOperador));
  }, [tecnicos, podeVerTodos, codOperador]);

  const filaFiltrada = useMemo(() => {
    const q = filaBusca.trim().toLowerCase();

    let arr = [...fila];

    if (q) {
      arr = arr.filter((item) => {
        const blob = [
          item.Data,
          item.Hora,
          item.Func,
          item.RazaoSocial,
          item.Cliente,
          item.PedidoCliente,
          item.DescrAtend,
          item.Cidade,
          item.Bairro,
        ]
          .map((x) => toStr(x).toLowerCase())
          .join(" ");

        return blob.includes(q);
      });
    }

    arr.sort((a, b) => {
      switch (filaSort.key) {
        case "Data": {
          const ta = parseAPIDate(a.Data);
          const tb = parseAPIDate(b.Data);
          if (ta !== tb) return ta - tb;
          return String(a.Hora || "").localeCompare(String(b.Hora || ""));
        }
        case "Cliente":
          return String(getClienteNome(a)).localeCompare(String(getClienteNome(b)));
        case "Func":
          return String(a.Func || "").localeCompare(String(b.Func || ""));
        default:
          return 0;
      }
    });

    if (filaSort.dir === "desc") arr.reverse();

    return arr;
  }, [fila, filaBusca, filaSort]);

  const mapQuery = useMemo(() => {
    const endereco = montarEndereco(mapTarget);
    if (endereco) return endereco;

    if (form.cliente) return form.cliente;

    return "SantSystem";
  }, [mapTarget, form.cliente]);

  const mapsEmbedUrl = useMemo(
    () => `https://www.google.com/maps?q=${encodeURIComponent(mapQuery)}&output=embed`,
    [mapQuery]
  );

  const mapsOpenUrl = useMemo(
    () => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(mapQuery)}`,
    [mapQuery]
  );

  const toggleFilaSort = (key) => {
    setFilaSort((prev) =>
      prev.key === key
        ? { key, dir: prev.dir === "asc" ? "desc" : "asc" }
        : { key, dir: "asc" }
    );
  };

  const goToPlanner = () => {
    setMobilePanel("planejar");

    requestAnimationFrame(() => {
      plannerRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      setTimeout(() => hrInicioRef.current?.focus(), 80);
    });
  };

  const bloquearAcao = (flag, msg) => {
    if (flag) return false;
    showError(msg);
    return true;
  };

  const carregarPermissaoAgenda = async () => {
    if (!idFuncionarioPermissao && !codOperador) {
      setPermissoes({ ...defaultPermissoes, carregado: true });
      showError("Funcionário logado sem IdFuncionario/codFunc na sessão.");
      return;
    }

    setLoadingPermissao(true);

    try {
      const paramsPermissao = idFuncionarioPermissao
        ? { idFuncionario: idFuncionarioPermissao }
        : { codFunc: codOperador };

      const { data } = await api.get("/permissoes/agenda", {
        params: paramsPermissao,
      });

      const root = data?.data ?? data ?? {};

      setPermissoes({
        podeAgendar: asBool(root?.podeAgendar),
        podeEditar: asBool(root?.podeEditar),
        podeExcluir: asBool(root?.podeExcluir),
        podeConfirmar: asBool(root?.podeConfirmar),
        podeFinalizar: asBool(root?.podeFinalizar),
        podeVerTodos: asBool(root?.podeVerTodos),
        podeEmitirRelatorio: asBool(root?.podeEmitirRelatorio),
        podeGerenciarPermissoes: asBool(root?.podeGerenciarPermissoes),
        carregado: true,
        encontrado: asBool(root?.encontrado),
        bloqueado: asBool(root?.bloqueado),
        funcionario: root?.funcionario || null,
        vigenciaInicio: root?.vigenciaInicio || null,
        vigenciaFim: root?.vigenciaFim || null,
        motivo: root?.motivo || null,
        observacao: root?.observacao || null,
        escopo: root?.escopo || "GLOBAL",
        valorEscopo: root?.valorEscopo || null,
        permissoesDetalhe: Array.isArray(root?.permissoesDetalhe)
          ? root.permissoesDetalhe
          : [],
      });
    } catch (err) {
      setPermissoes({ ...defaultPermissoes, carregado: true });
      showError(err?.response?.data?.message || "Falha ao verificar permissão de agenda.");
    } finally {
      setLoadingPermissao(false);
    }
  };

  const carregarTecnicos = async () => {
    try {
      const { data } = await api.get("/loginUser");
      const arr = Array.isArray(data) ? data : [];

      setTecnicos(arr);

      const self = arr.find((u) => String(u.codFunc) === String(codOperador));

      if (self) {
        setForm((p) => ({
          ...p,
          codFunc: String(self.codFunc),
          tecnico: self.nome || self.RazaoSocial || self.Nome || "",
        }));
      }
    } catch {
      setTecnicos([]);
      showError("Falha ao carregar técnicos.");
    }
  };

  const carregarAgenda = async () => {
    if (!form.codFunc || !form.dataISO) {
      showError("Selecione técnico e data.");
      return;
    }

    if (!podeVerTodos && String(form.codFunc) !== String(codOperador)) {
      showError("Sem permissão para visualizar agenda de outros técnicos.");
      return;
    }

    setLoadingAgenda(true);

    try {
      const { data } = await api.get("/agendamentos", {
        params: {
          codFunc: form.codFunc,
          data: form.dataISO,
          status: "pendente",
        },
      });

      setListaAgenda(Array.isArray(data) ? data : []);
      setRotaOtimizada(null);
      setRotaErro("");
    } catch (err) {
      showError(err?.response?.data?.message || "Falha ao carregar agenda.");
    } finally {
      setLoadingAgenda(false);
    }
  };

  const carregarFila = async () => {
    setLoadingFila(true);

    const tentativas = [
      { url: "/agendamentos/fila-agendamentos" },
      { url: "/chamados/fila-agendamentos" },
      { url: "/chamados", params: { agendamento: 1 } },
    ];

    for (const t of tentativas) {
      try {
        const { data } = await api.get(t.url, { params: t.params });
        setFila(Array.isArray(data) ? data : []);
        setLoadingFila(false);
        return;
      } catch {}
    }

    setFila([]);
    setLoadingFila(false);
  };

  useEffect(() => {
    setForm((p) => ({ ...p, funcAgendou: getNomeOperador() }));
    carregarTecnicos();
    carregarPermissaoAgenda();
    carregarFila();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!podeVerTodos && codOperador && form.codFunc && String(form.codFunc) !== String(codOperador)) {
      const self = tecnicos.find((u) => String(u.codFunc) === String(codOperador));

      setForm((p) => ({
        ...p,
        codFunc: String(codOperador),
        tecnico: self ? self.nome || self.RazaoSocial || self.Nome || "" : p.tecnico,
      }));
    }
  }, [podeVerTodos, codOperador, form.codFunc, tecnicos]);

  useEffect(() => {
    const s = minuteOf(form.hrInicio);
    const d = minuteOf(form.tempoExec);
    const fim =
      s !== 999999 && d !== 999999
        ? `${String(Math.floor(((s + d) % 1440) / 60)).padStart(2, "0")}:${String((s + d) % 60).padStart(2, "0")}`
        : "";

    setForm((p) => (p.hrFim === fim ? p : { ...p, hrFim: fim }));
  }, [form.hrInicio, form.tempoExec]);

  useEffect(() => {
    if (form.codFunc && form.dataISO) {
      carregarAgenda();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.codFunc, form.dataISO]);

  const onClienteChange = (cli) => {
    setClienteSelecionado(cli || null);

    if (!cli) {
      setForm((p) => ({ ...p, chvCad: "", cliente: "" }));
      setMapTarget(filaSelecionada || null);
      return;
    }

    const normalizado = normalizeClienteFromSelect(cli);

    setForm((p) => ({
      ...p,
      chvCad: String(normalizado.CodigoCad || ""),
      cliente: normalizado.RazaoSocial || "",
    }));

    setMapTarget(normalizado.Raw || normalizado);
  };

  const onChangeTecnico = (e) => {
    const cod = e.target.value;

    if (!podeVerTodos && String(cod) !== String(codOperador)) {
      showError("Sem permissão para selecionar outro técnico.");
      return;
    }

    const t = tecnicos.find((x) => String(x.codFunc) === String(cod));

    setForm((p) => ({
      ...p,
      codFunc: cod,
      tecnico: t ? t.nome || t.RazaoSocial || t.Nome || "" : "",
    }));
  };

  const validar = () => {
    if (modoEdicao) {
      if (!podeEditar) {
        showError("Sem permissão para editar agendamento.");
        return false;
      }
    } else if (!podeCriar) {
      showError("Sem permissão para criar agendamento.");
      return false;
    }

    if (!form.codFunc || !form.tecnico) {
      showError("Selecione o técnico.");
      return false;
    }
    if (!form.chvCad || !form.cliente) {
      showError("Selecione um cliente válido.");
      return false;
    }
    if (!form.dataISO) {
      showError("Informe a data da visita.");
      return false;
    }
    if (!/^\d{2}:\d{2}$/.test(form.hrInicio)) {
      showError("Hora de início inválida.");
      return false;
    }
    if (!/^\d{2}:\d{2}$/.test(form.tempoExec)) {
      showError("Tempo de execução inválido.");
      return false;
    }
    if (!form.online) {
      showError("Selecione o tipo de atendimento.");
      return false;
    }
    if (form.confirmado && !toStr(form.contatoConfirmacao)) {
      showError("Informe o contato de confirmação.");
      return false;
    }

    return true;
  };

  const montarPayload = () => ({
    Tecnico: form.tecnico,
    ChvFunc: String(form.codFunc),
    ChvCad: String(form.chvCad),
    Cliente: form.cliente,
    dataISO: form.dataISO,
    HrInicio: form.hrInicio,
    TempoExec: form.tempoExec,
    HrFim: form.hrFim || undefined,
    DescrServ: form.descrServ,
    PedidoCliente: form.pedidoCliente || "",
    Anotacoes: form.anotacoes || "",
    ResolvidoNao: "0",
    Finalizacao: "0",
    KmDia: form.kmDia || "",
    Veiculo: form.online === "PRESENCIAL" ? form.veiculo || "" : "",
    Placa: form.online === "PRESENCIAL" ? form.placa || "" : "",
    Pendente: form.confirmado ? "Confirmado" : "Pendente",
    ContatoConfirmacao: form.confirmado ? form.contatoConfirmacao || "" : "",
    FuncAgendou: form.funcAgendou || "",
    Online: form.online,
    IdChamados: form.idChamados ?? null,
  });

  const checarDuplicidadeCliente = async () => {
    try {
      const { data } = await api.get("/agendamentos/pendente-por-cliente", {
        params: { chvCad: form.chvCad },
      });
      return data;
    } catch {
      return { existe: false };
    }
  };

  const handleGravar = async () => {
    if (!validar()) return;

    setLoading(true);

    try {
      const dup = await checarDuplicidadeCliente();

      if (dup?.existe && dup?.ultimo) {
        const msg = `Já existe agendamento pendente para este cliente (ID ${dup.ultimo.id}) em ${dup.ultimo.DataISO} às ${dup.ultimo.HrInicio}.\n\nDeseja continuar mesmo assim?`;

        if (!window.confirm(msg)) {
          setLoading(false);
          return;
        }
      }

      const { data } = await api.post("/agendamentos", montarPayload());

      showSuccess(`Agendamento gravado${data?.id ? ` (#${data.id})` : ""}.`);

      setAgendamentoSelecionado(null);
      setFilaSelecionada(null);
      await Promise.all([carregarAgenda(), carregarFila()]);
      handleLimpar(true);
    } catch (err) {
      showError(err?.response?.data?.message || "Falha ao gravar agendamento.");
    } finally {
      setLoading(false);
    }
  };

  const handleAtualizar = async () => {
    if (!agendamentoSelecionado || !validar()) return;

    setLoading(true);

    try {
      await api.put(`/agendamentos/${agendamentoSelecionado}`, montarPayload());

      showSuccess("Agendamento atualizado.");
      setAgendamentoSelecionado(null);
      await carregarAgenda();
      handleLimpar(true);
    } catch (err) {
      showError(err?.response?.data?.message || "Falha ao atualizar agendamento.");
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmar = async (row) => {
    if (bloquearAcao(podeConfirmar, "Sem permissão para confirmar agendamento.")) return;

    try {
      const contato = window.prompt("Contato que confirmou:", form.contatoConfirmacao || "");
      if (!contato) return;

      await api.patch(`/agendamentos/${row.id}/confirmar`, {
        contatoConfirmacao: contato,
      });

      showSuccess("Agendamento confirmado.");
      carregarAgenda();
    } catch (err) {
      showError(err?.response?.data?.message || "Falha ao confirmar.");
    }
  };

  const handleFinalizar = async (row) => {
    if (bloquearAcao(podeFinalizar, "Sem permissão para finalizar agendamento.")) return;

    try {
      if (!window.confirm(`Finalizar agendamento #${row.id}?`)) return;

      await api.patch(`/agendamentos/${row.id}/finalizar`, { resolvidoNao: "1" });

      showSuccess("Agendamento finalizado.");
      carregarAgenda();
    } catch (err) {
      showError(err?.response?.data?.message || "Falha ao finalizar.");
    }
  };

  const handleExcluir = async (row) => {
    if (bloquearAcao(podeExcluir, "Sem permissão para excluir agendamento.")) return;

    try {
      if (!window.confirm(`Excluir agendamento #${row.id}? Essa ação não pode ser desfeita.`)) return;

      await api.delete(`/agendamentos/${row.id}`);

      showSuccess("Agendamento excluído.");
      carregarAgenda();
    } catch (err) {
      showError(err?.response?.data?.message || "Falha ao excluir.");
    }
  };

  const handleEditar = (row) => {
    if (bloquearAcao(podeEditar, "Sem permissão para editar agendamento.")) return;

    setClienteSelecionado(null);
    setFilaSelecionada(null);
    setMapTarget(row);
    setAgendamentoSelecionado(row.id);

    setForm((p) => ({
      ...p,
      tecnico: row.Tecnico || p.tecnico,
      codFunc: row.ChvFunc || p.codFunc,
      chvCad: row.ChvCad || p.chvCad,
      cliente: row.Cliente || p.cliente,
      dataISO: row.DataISO || p.dataISO,
      hrInicio: toHHMM(row.HrInicio) || p.hrInicio,
      tempoExec: toHHMM(row.TempoExec) || p.tempoExec,
      hrFim: toHHMM(row.HrFim) || "",
      descrServ: row.DescrServ || "",
      pedidoCliente: row.PedidoCliente || "",
      anotacoes: row.Anotacoes || "",
      online: row.Online || p.online,
      confirmado: row.Pendente === "Confirmado",
      contatoConfirmacao: row.ContatoConfirmacao || "",
      idChamados: row.IdChamados || null,
      kmDia: row.KmDia || "",
      veiculo: row.Veiculo || "",
      placa: row.Placa || "",
    }));

    goToPlanner();
  };

  const handleLimpar = (keepTec = true) => {
    setAgendamentoSelecionado(null);
    setFilaSelecionada(null);
    setClienteSelecionado(null);
    setMapTarget(null);

    setForm((p) => ({
      ...initialForm,
      funcAgendou: p.funcAgendou,
      codFunc: keepTec ? p.codFunc : "",
      tecnico: keepTec ? p.tecnico : "",
      dataISO: p.dataISO,
    }));
  };

  const vincularFila = (item) => {
    if (bloquearAcao(podeCriar, "Sem permissão para criar agendamento a partir da fila.")) return;

    setClienteSelecionado(null);
    setFilaSelecionada(item);
    setMapTarget(item);
    setAgendamentoSelecionado(null);

    setForm((p) => ({
      ...p,
      idChamados: getFilaId(item),
      chvCad: String(item.ChvCad ?? item.chvCad ?? ""),
      cliente: getClienteNome(item),
      descrServ: p.descrServ || item.DescrAtend || "",
      pedidoCliente: p.pedidoCliente || item.PedidoCliente || "",
      hrInicio: p.hrInicio || toHHMM(item.Hora),
      online: p.online || "ONLINE",
    }));

    goToPlanner();
  };

  const imprimirAgenda = () => {
    if (bloquearAcao(podeRelatorio, "Sem permissão para imprimir agenda.")) return;
    if (!form.codFunc || !form.dataISO) return showError("Selecione técnico e data antes de imprimir.");
    if (!listaAgenda.length) return showError("Nada para imprimir. Carregue a agenda do dia.");

    const esc = (s) =>
      String(s ?? "").replace(/[&<>]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]));

    const htmlItens = agendaOrdenada
      .map((r) => {
        const endereco = montarEndereco(r);
        const telefones = [r.Tel1, r.Tel2, r.Cel].map(toStr).filter(Boolean).join(" / ");
        const veicTxt = [r.Veiculo, r.Placa].map(toStr).filter(Boolean).join(" / ");

        return `
          <article class="slot">
            <div class="rowA">
              <div><b>Cliente:</b> ${esc(r.Cliente || "")}</div>
              <div><b>Horário:</b> ${esc(r.HrInicio || "")} · ${esc(r.TempoExec || "")}</div>
            </div>
            <div><b>Endereço:</b> ${esc(endereco || "")}</div>
            <div><b>Telefones:</b> ${esc(telefones || "")}</div>
            <div><b>Tipo:</b> ${esc(r.Online || "")} ${veicTxt ? `· <b>Veículo:</b> ${esc(veicTxt)}` : ""}</div>
            <div><b>Serviço:</b> ${esc(r.DescrServ || "")}</div>
            ${r.PedidoCliente ? `<div><b>Pedido:</b> ${esc(r.PedidoCliente)}</div>` : ""}
            <div class="obs"><b>Relato técnico:</b><div></div><div></div></div>
            <div class="sign">Assinatura do cliente: ____________________________________</div>
          </article>
        `;
      })
      .join("");

    const html = `
      <!doctype html>
      <html>
        <head>
          <meta charset="utf-8" />
          <title>Agenda - ${form.tecnico} - ${fmtISOToBR(form.dataISO)}</title>
          <style>
            @page { size: A4; margin: 10mm; }
            * { box-sizing: border-box; }
            body { font: 11px/1.35 Arial, sans-serif; color: #111827; }
            header { display:flex; justify-content:space-between; border-bottom:1px solid #d1d5db; padding-bottom:8px; margin-bottom:10px; }
            h1 { font-size:16px; margin:0; }
            .meta { color:#4b5563; margin-top:3px; }
            .slot { border:1px solid #d1d5db; border-radius:8px; padding:9px; margin-bottom:8px; break-inside:avoid; }
            .rowA { display:grid; grid-template-columns: 1.5fr .7fr; gap:8px; }
            .obs div { height:18px; border-bottom:1px solid #d1d5db; margin-top:5px; }
            .sign { margin-top:14px; }
          </style>
        </head>
        <body>
          <header>
            <div>
              <h1>Relação de clientes para visitas</h1>
              <div class="meta">Data: <b>${fmtISOToBR(form.dataISO)}</b></div>
            </div>
            <div>
              <div>Técnico</div>
              <b>${esc(form.tecnico || "")}</b>
            </div>
          </header>
          ${htmlItens}
        </body>
      </html>
    `;

    const w = window.open("", "_blank");
    if (!w) return;

    w.document.open();
    w.document.write(html);
    w.document.close();
    w.focus();

    setTimeout(() => {
      try {
        w.print();
      } catch {}
    }, 120);
  };

  const abrirRelatorio = () => {
    if (bloquearAcao(podeRelatorio, "Sem permissão para relatório.")) return;
    setRelOpen(true);
  };

  const calcularRotaOtimizada = async () => {
    if (!form.codFunc || !form.dataISO) {
      showError("Selecione técnico e data antes de calcular a rota.");
      return;
    }

    if (!agendaOrdenada.length) {
      showError("Carregue a agenda do dia antes de calcular a rota.");
      return;
    }

    if (!paradasRota.length) {
      showError("Nenhum agendamento presencial com endereço encontrado para montar a rota.");
      return;
    }

    setLoadingRota(true);
    setRotaErro("");

    try {
      const { data } = await api.post("/agendamentos/rota-otimizada", {
        voltarParaEmpresa,
        paradas: paradasRota,
      });

      const root = data?.data ?? data ?? {};

      setRotaOtimizada(root);
      setMobilePanel("mapa");

      showSuccess(
        `Rota calculada: ${formatKm(root.distanciaTotalKm)} · ${
          root.tempoTotalTexto || "tempo não informado"
        }.`
      );
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.details?.message ||
        "Falha ao calcular rota otimizada.";

      setRotaErro(msg);
      showError(msg);
    } finally {
      setLoadingRota(false);
    }
  };

  const limparRota = () => {
    setRotaOtimizada(null);
    setRotaErro("");
  };

  const PermissionMeta = () => {
    const temMeta =
      permissoes.vigenciaInicio ||
      permissoes.vigenciaFim ||
      permissoes.motivo ||
      permissoes.observacao;

    if (!temMeta) return null;

    return (
      <span className="agx-permission-meta">
        Vigência: {fmtVigenciaPermissao(permissoes.vigenciaInicio, permissoes.vigenciaFim)}
        {permissoes.motivo ? ` · ${permissoes.motivo}` : ""}
      </span>
    );
  };

  const PermissionBar = () => {
    if (loadingPermissao) {
      return <div className="agx-permission agx-permission--info">Validando permissões...</div>;
    }

    if (permissoes.carregado && !permissoes.encontrado) {
      return (
        <div className="agx-permission agx-permission--danger">
          Funcionário da sessão não localizado. Verifique IdFuncionario/codFunc do login.
        </div>
      );
    }

    if (permissoes.bloqueado) {
      return (
        <div className="agx-permission agx-permission--danger">
          Funcionário bloqueado ou inativo. Operações da agenda foram desabilitadas.
          <PermissionMeta />
        </div>
      );
    }

    if (!podeCriar) {
      return (
        <div className="agx-permission agx-permission--warning">
          Modo consulta. Sem permissão para criar agendamentos.
          <PermissionMeta />
        </div>
      );
    }

    return (
      <div className="agx-permission agx-permission--success">
        Operação liberada
        <span>Criar{podeEditar ? " · Editar" : ""}{podeConfirmar ? " · Confirmar" : ""}{podeFinalizar ? " · Finalizar" : ""}</span>
        <PermissionMeta />
      </div>
    );
  };

  const AgendaBadge = ({ row }) => {
    const confirmado = row?.Pendente === "Confirmado";

    return (
      <span className={`agx-badge ${confirmado ? "agx-badge--success" : "agx-badge--warning"}`}>
        {confirmado ? "Confirmado" : "Pendente"}
      </span>
    );
  };

  const TipoBadge = ({ tipo }) => (
    <span className={`agx-badge ${tipo === "PRESENCIAL" ? "agx-badge--purple" : "agx-badge--info"}`}>
      {tipo || "—"}
    </span>
  );

  return (
    <MainLayout>
      <div className="agx-screen">
        <header className="agx-header">
          <div className="agx-title">
            <span className="agx-eyebrow">Central operacional</span>
            <h1>Planejamento de Agenda</h1>
            <p>Fila, agenda do técnico e logística em uma visão única para reduzir retrabalho e deslocamentos ruins.</p>
          </div>

          <div className="agx-header-actions">
            <div className="agx-filter">
              <label>Data</label>
              <input
                type="date"
                value={form.dataISO}
                onChange={(e) => setForm((p) => ({ ...p, dataISO: e.target.value }))}
              />
            </div>

            <div className="agx-filter agx-filter--tech">
              <label>Técnico</label>
              <select value={form.codFunc} onChange={onChangeTecnico}>
                <option value="">Selecione</option>
                {tecnicosDisponiveis.map((u) => (
                  <option key={u.codFunc} value={u.codFunc}>
                    {u.nome || u.RazaoSocial || u.Nome}
                  </option>
                ))}
              </select>
            </div>

            <button type="button" className="agx-btn agx-btn--primary" onClick={carregarAgenda} disabled={loadingAgenda}>
              {loadingAgenda ? "Carregando..." : "Carregar"}
            </button>

            <button type="button" className="agx-btn agx-btn--ghost" onClick={carregarPermissaoAgenda} disabled={loadingPermissao}>
              Permissões
            </button>
          </div>
        </header>

        <section className="agx-kpi-strip">
          <div className="agx-kpi">
            <span>Agenda</span>
            <strong>{totalAgenda}</strong>
          </div>
          <div className="agx-kpi agx-kpi--success">
            <span>Confirmados</span>
            <strong>{totalConfirmados}</strong>
          </div>
          <div className="agx-kpi agx-kpi--warning">
            <span>Pendentes</span>
            <strong>{totalPendentes}</strong>
          </div>
          <div className="agx-kpi agx-kpi--info">
            <span>Fila</span>
            <strong>{totalFila}</strong>
          </div>

          <PermissionBar />
        </section>

        <nav className="agx-mobile-nav" aria-label="Navegação mobile da agenda">
          <button
            type="button"
            className={mobilePanel === "fila" ? "is-active" : ""}
            onClick={() => setMobilePanel("fila")}
          >
            Fila <span>{filaFiltrada.length}</span>
          </button>
          <button
            type="button"
            className={mobilePanel === "planejar" ? "is-active" : ""}
            onClick={() => setMobilePanel("planejar")}
          >
            Planejar
          </button>
          <button
            type="button"
            className={mobilePanel === "agenda" ? "is-active" : ""}
            onClick={() => setMobilePanel("agenda")}
          >
            Agenda <span>{totalAgenda}</span>
          </button>
          <button
            type="button"
            className={mobilePanel === "mapa" ? "is-active" : ""}
            onClick={() => setMobilePanel("mapa")}
          >
            Mapa
          </button>
        </nav>

        <main className="agx-workbench">
          <section className={`agx-panel agx-queue ${mobilePanel === "fila" ? "is-mobile-active" : ""}`}>
            <div className="agx-panel-head">
              <div>
                <span className="agx-eyebrow">Entrada</span>
                <h2>Fila pendente</h2>
              </div>

              <button type="button" className="agx-btn agx-btn--soft agx-btn--small" onClick={carregarFila} disabled={loadingFila}>
                {loadingFila ? "..." : "Atualizar"}
              </button>
            </div>

            <div className="agx-queue-tools">
              <input
                type="search"
                placeholder="Buscar cliente, pedido, técnico..."
                value={filaBusca}
                onChange={(e) => setFilaBusca(e.target.value)}
              />

              <div className="agx-sortbar">
                <button type="button" onClick={() => toggleFilaSort("Data")}>
                  Data {filaSort.key === "Data" ? (filaSort.dir === "asc" ? "▲" : "▼") : "↕"}
                </button>
                <button type="button" onClick={() => toggleFilaSort("Cliente")}>
                  Cliente {filaSort.key === "Cliente" ? (filaSort.dir === "asc" ? "▲" : "▼") : "↕"}
                </button>
              </div>
            </div>

            <div className="agx-queue-list">
              {filaFiltrada.length === 0 && (
                <div className="agx-empty">
                  <strong>Fila vazia</strong>
                  <span>Nenhuma pendência encontrada para agendamento.</span>
                </div>
              )}

              {filaFiltrada.map((item) => {
                const id = getFilaId(item);
                const cliente = getClienteNome(item) || "Cliente não informado";
                const pedido = item.PedidoCliente || item.DescrAtend || "Sem descrição";
                const dataHora = `${fmtDataBR(item.Data)}${item.Hora ? ` · ${String(item.Hora).slice(0, 5)}` : ""}`;
                const selecionado = String(getFilaId(filaSelecionada)) === String(id);

                return (
                  <article
                    key={id || `${cliente}-${dataHora}`}
                    className={`agx-queue-card ${selecionado ? "is-selected" : ""}`}
                  >
                    <button
                      type="button"
                      className="agx-queue-main"
                      onClick={() => {
                        setFilaSelecionada(item);
                        setMapTarget(item);
                        setMobilePanel("mapa");
                      }}
                    >
                      <span className="agx-date-chip">{dataHora}</span>
                      <h3>{cliente}</h3>
                      <p>{trunc(pedido, 118)}</p>
                      <div className="agx-queue-meta">
                        <span>{item.Func || "Sem responsável"}</span>
                        {montarEndereco(item) ? <span>Com endereço</span> : <span>Sem endereço</span>}
                      </div>
                    </button>

                    <div className="agx-queue-actions">
                      <button
                        type="button"
                        className="agx-btn agx-btn--primary agx-btn--small"
                        onClick={() => vincularFila(item)}
                        disabled={!podeCriar}
                        title={!podeCriar ? "Sem permissão para agendar" : ""}
                      >
                        Planejar
                      </button>
                    </div>
                  </article>
                );
              })}
            </div>
          </section>

          <section
            className={`agx-panel agx-planner ${mobilePanel === "planejar" ? "is-mobile-active" : ""}`}
            ref={plannerRef}
          >
            <div className="agx-panel-head">
              <div>
                <span className="agx-eyebrow">{modoEdicao ? "Edição" : "Planejamento"}</span>
                <h2>{modoEdicao ? `Agendamento #${agendamentoSelecionado}` : "Novo agendamento"}</h2>
              </div>

              <button type="button" className="agx-btn agx-btn--ghost agx-btn--small" onClick={() => handleLimpar(true)}>
                Limpar
              </button>
            </div>

            {filaSelecionada && !modoEdicao && (
              <div className="agx-selected-call">
                <span>Fila selecionada</span>
                <strong>{getClienteNome(filaSelecionada)}</strong>
                <small>{trunc(filaSelecionada.PedidoCliente || filaSelecionada.DescrAtend, 140)}</small>
              </div>
            )}

            <div className="agx-form-grid">
              <div className="agx-form-field agx-span-2">
                <label>Cliente</label>
                <SelectCliente
                  value={clienteSelecionado}
                  onChange={onClienteChange}
                  includeInactiveSearch={true}
                  autoReactivateOnSelect={false}
                  isDisabled={!podeCriar && !modoEdicao}
                />

                {form.cliente && (
                  <small>
                    Selecionado: <b>{form.cliente}</b> #{form.chvCad}
                  </small>
                )}
              </div>

              <div className="agx-form-field">
                <label>Início</label>
                <input
                  ref={hrInicioRef}
                  type="time"
                  value={form.hrInicio}
                  onChange={(e) => setForm((p) => ({ ...p, hrInicio: e.target.value }))}
                  disabled={!podeCriar && !modoEdicao}
                />
              </div>

              <div className="agx-form-field">
                <label>Duração</label>
                <input
                  type="time"
                  value={form.tempoExec}
                  onChange={(e) => setForm((p) => ({ ...p, tempoExec: e.target.value }))}
                  disabled={!podeCriar && !modoEdicao}
                />
              </div>

              <div className="agx-form-field">
                <label>Término</label>
                <input type="time" value={form.hrFim} disabled readOnly placeholder="auto" />
              </div>

              <div className="agx-form-field">
                <label>Tipo</label>
                <div className="agx-segmented">
                  <button
                    type="button"
                    className={form.online === "ONLINE" ? "is-active" : ""}
                    onClick={() => setForm((p) => ({ ...p, online: "ONLINE" }))}
                    disabled={!podeCriar && !modoEdicao}
                  >
                    Online
                  </button>
                  <button
                    type="button"
                    className={form.online === "PRESENCIAL" ? "is-active" : ""}
                    onClick={() => setForm((p) => ({ ...p, online: "PRESENCIAL" }))}
                    disabled={!podeCriar && !modoEdicao}
                  >
                    Presencial
                  </button>
                </div>
              </div>

              <div className="agx-form-field">
                <label>Confirmado?</label>
                <label className="agx-switch">
                  <input
                    type="checkbox"
                    checked={form.confirmado}
                    onChange={(e) => setForm((p) => ({ ...p, confirmado: e.target.checked }))}
                    disabled={!podeConfirmar && !podeCriar && !modoEdicao}
                  />
                  <span>{form.confirmado ? "Sim" : "Não"}</span>
                </label>
              </div>

              <div className="agx-form-field agx-span-2">
                <label>Contato de confirmação</label>
                <input
                  type="text"
                  placeholder="Nome ou telefone"
                  value={form.contatoConfirmacao}
                  onChange={(e) => setForm((p) => ({ ...p, contatoConfirmacao: e.target.value }))}
                  disabled={!form.confirmado || (!podeCriar && !modoEdicao)}
                />
              </div>

              {form.online === "PRESENCIAL" && (
                <>
                  <div className="agx-form-field">
                    <label>Veículo</label>
                    <input
                      type="text"
                      value={form.veiculo}
                      onChange={(e) => setForm((p) => ({ ...p, veiculo: e.target.value }))}
                    />
                  </div>

                  <div className="agx-form-field">
                    <label>Placa</label>
                    <input
                      type="text"
                      value={form.placa}
                      onChange={(e) => setForm((p) => ({ ...p, placa: e.target.value }))}
                    />
                  </div>

                  <div className="agx-form-field">
                    <label>Km do dia</label>
                    <input
                      type="text"
                      value={form.kmDia}
                      onChange={(e) => setForm((p) => ({ ...p, kmDia: e.target.value }))}
                    />
                  </div>
                </>
              )}

              <div className="agx-form-field agx-span-2">
                <label>Serviço a executar</label>
                <input
                  type="text"
                  value={form.descrServ}
                  onChange={(e) => setForm((p) => ({ ...p, descrServ: e.target.value }))}
                  placeholder="Informe o serviço previsto"
                  disabled={!podeCriar && !modoEdicao}
                />
              </div>

              <div className="agx-form-field agx-span-2">
                <label>Pedido do cliente</label>
                <input
                  type="text"
                  value={form.pedidoCliente}
                  onChange={(e) => setForm((p) => ({ ...p, pedidoCliente: e.target.value }))}
                  placeholder="Solicitação ou observação do cliente"
                  disabled={!podeCriar && !modoEdicao}
                />
              </div>

              <div className="agx-form-field agx-span-4">
                <label>Anotações internas</label>
                <textarea
                  rows={3}
                  value={form.anotacoes}
                  onChange={(e) => setForm((p) => ({ ...p, anotacoes: e.target.value }))}
                  placeholder="Informações internas para apoio ao técnico"
                  disabled={!podeCriar && !modoEdicao}
                />
              </div>
            </div>

            <div className="agx-planner-actions">
              <button
                type="button"
                className="agx-btn agx-btn--primary"
                onClick={modoEdicao ? handleAtualizar : handleGravar}
                disabled={loading || (modoEdicao ? !podeEditar : !podeCriar)}
              >
                {loading
                  ? modoEdicao
                    ? "Atualizando..."
                    : "Gravando..."
                  : modoEdicao
                  ? "Atualizar agendamento"
                  : "Gravar agendamento"}
              </button>

              <button type="button" className="agx-btn agx-btn--outline" onClick={imprimirAgenda} disabled={!listaAgenda.length || !podeRelatorio}>
                Imprimir agenda
              </button>

              <button type="button" className="agx-btn agx-btn--soft" onClick={abrirRelatorio} disabled={!podeRelatorio}>
                Relatório
              </button>
            </div>
          </section>

          <aside className={`agx-panel agx-map-panel ${mobilePanel === "mapa" ? "is-mobile-active" : ""}`}>
            <div className="agx-panel-head">
              <div>
                <span className="agx-eyebrow">Logística</span>
                <h2>Mapa e roteiro</h2>
              </div>

              <div className="agx-map-actions">
                <button
                  type="button"
                  className="agx-btn agx-btn--primary agx-btn--small"
                  onClick={calcularRotaOtimizada}
                  disabled={loadingRota || !agendaOrdenada.length || !paradasRota.length}
                  title={
                    !paradasRota.length
                      ? "Carregue agendamentos presenciais com endereço"
                      : ""
                  }
                >
                  {loadingRota ? "Calculando..." : `Calcular rota (${paradasRota.length})`}
                </button>

                {rotaOtimizada?.googleMapsUrl ? (
                  <a
                    className="agx-btn agx-btn--soft agx-btn--small"
                    href={rotaOtimizada.googleMapsUrl}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Abrir rota
                  </a>
                ) : (
                  <a
                    className="agx-btn agx-btn--soft agx-btn--small"
                    href={mapsOpenUrl}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Abrir mapa
                  </a>
                )}
              </div>
            </div>

            <div className="agx-map-card">
              <iframe
                title="Mapa do atendimento"
                src={mapsEmbedUrl}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>

            <div className="agx-map-summary">
              <span>{rotaOtimizada ? "Roteiro calculado" : "Destino em análise"}</span>
              <strong>
                {rotaOtimizada
                  ? `${rotaOtimizada.quantidadeParadasValidas || paradasRota.length} paradas · ${
                      rotaOtimizada.tempoTotalTexto || "tempo não informado"
                    }`
                  : form.cliente || getClienteNome(filaSelecionada) || "Nenhum cliente selecionado"}
              </strong>
              <small>
                {rotaOtimizada
                  ? `${formatKm(rotaOtimizada.distanciaTotalKm)} · ${
                      rotaOtimizada.metodoOrdenacao || "rota calculada"
                    }${rotaOtimizada.cache ? " · cache" : ""}`
                  : mapQuery}
              </small>
            </div>

            <div className="agx-route-options">
              <label className="agx-switch agx-switch--compact">
                <input
                  type="checkbox"
                  checked={voltarParaEmpresa}
                  onChange={(e) => {
                    setVoltarParaEmpresa(e.target.checked);
                    limparRota();
                  }}
                />
                <span>Voltar para a empresa no final</span>
              </label>

              <button
                type="button"
                className="agx-btn agx-btn--ghost agx-btn--small"
                onClick={limparRota}
                disabled={!rotaOtimizada && !rotaErro}
              >
                Limpar rota
              </button>
            </div>

            {rotaErro && (
              <div className="agx-route-alert">
                <strong>Falha ao calcular rota</strong>
                <span>{rotaErro}</span>
              </div>
            )}

            {rotaOtimizada && (
              <section className="agx-route-card">
                <div className="agx-route-stats">
                  <div>
                    <span>Distância</span>
                    <strong>{formatKm(rotaOtimizada.distanciaTotalKm)}</strong>
                  </div>

                  <div>
                    <span>Tempo</span>
                    <strong>{rotaOtimizada.tempoTotalTexto || "—"}</strong>
                  </div>

                  <div>
                    <span>Método</span>
                    <strong>Proximidade</strong>
                  </div>
                </div>

                <p>
                  Rota calculada a partir da empresa usando os agendamentos presenciais
                  com endereço. A ordem é sugerida por proximidade.
                </p>

                <div className="agx-route-links">
                  {rotaOtimizada.openStreetMapUrl && (
                    <a
                      className="agx-btn agx-btn--outline agx-btn--small"
                      href={rotaOtimizada.openStreetMapUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      OpenStreetMap
                    </a>
                  )}

                  {rotaOtimizada.googleMapsUrl && (
                    <a
                      className="agx-btn agx-btn--outline agx-btn--small"
                      href={rotaOtimizada.googleMapsUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Google Maps
                    </a>
                  )}
                </div>

                <ol className="agx-route-list">
                  {(rotaOtimizada.ordemOtimizada || []).map((stop) => {
                    const original =
                      stop?.idAgendamento != null
                        ? agendaPorId.get(String(stop.idAgendamento))
                        : null;

                    return (
                      <li key={`${stop.ordem}-${stop.idAgendamento || stop.cliente}`}>
                        <span className="agx-route-order">{stop.ordem}</span>

                        <div>
                          <strong>{stop.cliente || original?.Cliente || "Cliente"}</strong>
                          <small>
                            {original?.HrInicio ? `${original.HrInicio} · ` : ""}
                            {stop.endereco || original?.EnderecoCompleto || "Endereço não informado"}
                          </small>
                        </div>
                      </li>
                    );
                  })}
                </ol>

                {Array.isArray(rotaOtimizada.avisos) && rotaOtimizada.avisos.length > 0 && (
                  <div className="agx-route-warnings">
                    <strong>Avisos</strong>
                    {rotaOtimizada.avisos.map((aviso, idx) => (
                      <span key={`${aviso.idAgendamento || idx}-${aviso.message}`}>
                        {aviso.cliente ? `${aviso.cliente}: ` : ""}
                        {aviso.message}
                      </span>
                    ))}
                  </div>
                )}
              </section>
            )}

            <div className={`agx-agenda-side ${mobilePanel === "agenda" ? "is-mobile-active" : ""}`}>
              <div className="agx-side-head">
                <span className="agx-eyebrow">Agenda do dia</span>
                <button type="button" className="agx-btn agx-btn--ghost agx-btn--small" onClick={() => setMobilePanel("agenda")}>
                  Ver
                </button>
              </div>

              <div className="agx-timeline">
                {agendaOrdenada.length === 0 && (
                  <div className="agx-empty agx-empty--compact">
                    <strong>Sem agenda</strong>
                    <span>Nenhum compromisso carregado.</span>
                  </div>
                )}

                {agendaOrdenada.map((row) => {
                  const routeInfo = rotaPorAgendamento.get(String(getAgendaId(row)));

                  return (
                    <article
                      key={row.id}
                      className={`agx-timeline-item ${routeInfo ? "is-route-stop" : ""}`}
                    >
                      <div className="agx-timeline-time">
                        <strong>{row.HrInicio || "—"}</strong>
                        <span>{row.TempoExec || "—"}</span>
                        {routeInfo && (
                          <em title="Ordem sugerida na rota">#{routeInfo.ordem}</em>
                        )}
                      </div>

                      <div className="agx-timeline-body">
                        <div className="agx-timeline-top">
                          <h3>{row.Cliente || "Cliente não informado"}</h3>
                          <AgendaBadge row={row} />
                        </div>

                        <p>{trunc(row.DescrServ || "Sem descrição", 95)}</p>

                        <div className="agx-timeline-actions">
                          <TipoBadge tipo={row.Online} />
                          <button type="button" onClick={() => handleEditar(row)} disabled={!podeEditar}>
                            Editar
                          </button>
                          <button type="button" onClick={() => handleConfirmar(row)} disabled={!podeConfirmar}>
                            Confirmar
                          </button>
                          <button type="button" onClick={() => handleFinalizar(row)} disabled={!podeFinalizar}>
                            Finalizar
                          </button>
                          <button type="button" className="danger" onClick={() => handleExcluir(row)} disabled={!podeExcluir}>
                            Excluir
                          </button>
                        </div>
                      </div>
                    </article>
                  );
                })}
              </div>
            </div>
          </aside>
        </main>

        <RelatorioAgendamentosModal
          open={relOpen}
          onClose={() => setRelOpen(false)}
          tecnicos={tecnicos}
          inicioDefault={form.dataISO}
          fimDefault={form.dataISO}
          tecnicoDefault={form.tecnico || "TODOS"}
        />
      </div>
    </MainLayout>
  );
}
